<template>
  <div id="app" class="app-main">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style lang = 'less'>
@import "./styles/common.less";
.com-family{
   font-family: SimHei;
}
html,body{
    width: 100%;
    height: 100%;
    background: #f0f0f0;
    margin: 0;
    .com-family;
}
button{
  .com-family;
}
 /* element-ui table表格控件表头与内容列不对齐 */
body .el-table th.gutter{
  display: table-cell!important;
}
.app-main{
    width: 100%;
    height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/App.vue